import React from "react";

import svg from "../../assets/images/icons/steps/Show form f.svg";

export const FormStepIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Form Step"}
    />
);
